import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaWhatsapp, FaSearch, FaFileInvoiceDollar, FaShoppingCart, FaPlane, FaAmazon } from "react-icons/fa";
import { motion } from "framer-motion";

const CompraAsistidaSection = () => {
  const container = { hidden: {}, show: { transition: { staggerChildren: 0.2 } } };
  const item = { hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0, transition: { duration: 0.5 } } };

  return (
    <section className='py-5 bg-light' id='compra-asistida'>
      <Container>
        <Row className='mb-5 text-center'>
          <Col>
            <motion.div initial={{ opacity: 0, y: -20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
              <h2 className='display-5 fw-bold mb-3' style={{ color: "#182848" }}>Compra Asistida</h2>
              <h4 className='text-muted mb-4'>Compra en Estados Unidos y México, nosotros nos encargamos del resto.</h4>
              <p className='lead' style={{ color: "#5a6a8a", maxWidth: "800px", margin: "0 auto" }}>
                ¿Encontraste un producto que quieres comprar, pero no tienes tarjeta, no te sientes cómodo utilizando una plataforma o simplemente prefieres dejar el proceso en nuestras manos?
              </p>
              <p className='lead mt-3 fw-bold' style={{ color: "#2196f3" }}>
                Con MBOX Compra Asistida podemos ayudarte a realizar tu compra y traerla hasta Honduras de forma sencilla.
              </p>
            </motion.div>
          </Col>
        </Row>

        <Row className='mb-5'>
          <Col>
            <h3 className='text-center fw-bold mb-4' style={{ color: "#182848" }}>¿Cómo funciona?</h3>
            <motion.div variants={container} initial='hidden' whileInView='show' viewport={{ once: true }} className="row g-4">
              
              <Col md={6} lg={4}>
                <motion.div variants={item} className="h-100">
                  <Card className='h-100 border-0 shadow-sm rounded-4 text-center p-3'>
                    <Card.Body>
                      <div className='bg-primary bg-opacity-10 text-primary rounded-circle d-inline-flex p-3 mb-3'>
                        <FaWhatsapp size={28} />
                      </div>
                      <h5 className='fw-bold'>01. Envíanos el enlace</h5>
                      <p className='text-muted mb-2'>Mándanos por WhatsApp el enlace del producto que deseas comprar.</p>
                      <a href="https://wa.me/50498644314" target="_blank" rel="noreferrer" className="btn btn-outline-success rounded-pill fw-bold mt-2">
                        WhatsApp: 9864-4314
                      </a>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>

              <Col md={6} lg={4}>
                <motion.div variants={item} className="h-100">
                  <Card className='h-100 border-0 shadow-sm rounded-4 text-center p-3'>
                    <Card.Body>
                      <div className='bg-info bg-opacity-10 text-info rounded-circle d-inline-flex p-3 mb-3'>
                        <FaSearch size={28} />
                      </div>
                      <h5 className='fw-bold'>02. Verificamos tu producto</h5>
                      <p className='text-muted'>Revisamos su disponibilidad, las condiciones de compra y si el producto puede ser enviado y trasladado a Honduras de acuerdo con las restricciones aduaneras aplicables.</p>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>

              <Col md={6} lg={4}>
                <motion.div variants={item} className="h-100">
                  <Card className='h-100 border-0 shadow-sm rounded-4 text-center p-3'>
                    <Card.Body>
                      <div className='bg-warning bg-opacity-10 text-warning rounded-circle d-inline-flex p-3 mb-3'>
                        <FaFileInvoiceDollar size={28} />
                      </div>
                      <h5 className='fw-bold'>03. Te brindamos una cotización</h5>
                      <p className='text-muted'>Te informamos el <strong>costo estimado de tu compra</strong> y el <strong>tiempo aproximado de llegada a Honduras</strong>, para que puedas decidir antes de realizarla.</p>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>

              <Col md={6} lg={4}>
                <motion.div variants={item} className="h-100">
                  <Card className='h-100 border-0 shadow-sm rounded-4 text-center p-3'>
                    <Card.Body>
                      <div className='bg-success bg-opacity-10 text-success rounded-circle d-inline-flex p-3 mb-3'>
                        <FaShoppingCart size={28} />
                      </div>
                      <h5 className='fw-bold'>04. Nosotros realizamos la compra</h5>
                      <p className='text-muted'>Una vez aprobada la cotización, realizamos la compra y recibimos tu paquete en nuestra <strong>bodega en Miami</strong>.</p>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>

              <Col md={6} lg={4}>
                <motion.div variants={item} className="h-100">
                  <Card className='h-100 border-0 shadow-sm rounded-4 text-center p-3'>
                    <Card.Body>
                      <div className='bg-danger bg-opacity-10 text-danger rounded-circle d-inline-flex p-3 mb-3'>
                        <FaPlane size={28} />
                      </div>
                      <h5 className='fw-bold'>05. Lo traemos a Honduras</h5>
                      <p className='text-muted mb-2'>Tu paquete será trasladado a Honduras según el servicio que elijas:</p>
                      <p className='fw-bold text-dark'>Aéreo Estándar | Aéreo Express | Marítimo</p>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>

            </motion.div>
          </Col>
        </Row>

        <Row className='mt-5'>
          <Col lg={6} className='mb-4 mb-lg-0'>
            <Card className='h-100 border-0 shadow rounded-4' style={{ background: "linear-gradient(135deg, #182848 0%, #2b4379 100%)", color: "white" }}>
              <Card.Body className='p-5 d-flex flex-column justify-content-center'>
                <h3 className='fw-bold mb-3'>Compra en las plataformas que prefieras</h3>
                <p className='fs-5 mb-4' style={{ opacity: 0.9 }}>
                  Realizamos compras asistidas en <strong>Estados Unidos y México</strong>, ayudándote a adquirir productos de diferentes tiendas y plataformas en línea.
                </p>
                <p className='fs-5' style={{ opacity: 0.9 }}>
                  Si no tienes tarjeta, tienes dudas sobre una plataforma o simplemente quieres contar con el apoyo de nuestro equipo, <strong>nosotros te ayudamos durante el proceso.</strong>
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <Card className='h-100 border-0 shadow rounded-4 bg-white'>
              <Card.Body className='p-5 d-flex flex-column justify-content-center'>
                <div className='text-center mb-4'>
                  <FaAmazon size={60} color="#FF9900" />
                </div>
                <h3 className='fw-bold mb-3 text-center' style={{ color: "#182848" }}>Beneficios adicionales con Amazon Prime</h3>
                <p className='fs-5 text-muted text-center'>
                  En MBOX también contamos con <strong>Amazon Prime</strong>, por lo que podemos ayudarte a aprovechar los beneficios disponibles en tus compras de Amazon, incluyendo promociones y descuentos cuando estén disponibles.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CompraAsistidaSection;
